import { create } from 'zustand';
import { FirebaseApp } from 'firebase/app';

interface IStore {
  firebaseApp?: () => FirebaseApp;
  setFirebaseApp: (app: FirebaseApp) => void;
  remoteConfigValues?: { [key: string]: any };
  setRemoteConfigValues: (config: any) => void;
}

export const useFirebaseStore = create<IStore>(set => ({
  firebaseApp: undefined,
  setFirebaseApp: firebaseApp =>
    set({
      firebaseApp: () => firebaseApp
    }),
  remoteConfigValues: undefined,
  setRemoteConfigValues: remoteConfigValues =>
    set({
      remoteConfigValues: remoteConfigValues
    })
}));
